<template>
  <div class="account-center" no-body>
    <tabsLayout>
      <b-tabs
        v-model="tabIndex"
        card
        lazy
        content-class="my-0"
        active-nav-item-class="font-weight-bold"
      >
        <b-tab
          v-for="tab of tabs"
          :key="tab.key"
          :title="tab.label"
          @click="$router.push({ name: tab.componentName })"
          class="px-0"
        >
        </b-tab>
      </b-tabs>
      <listLayout>
        <router-view></router-view>
      </listLayout>
    </tabsLayout>
  </div>
</template>

<script>
import tabsLayout from "@/layout/TabsLayout.vue";
import listLayout from "@/layout/ListLayout.vue";
export default {
  components: {
    tabsLayout,
    listLayout
  },
  created() {
    const tabName = this.$route.path.split("/")[2];
    this.tabIndex = this.tabs.findIndex(item => {
      return item.componentName === tabName;
    });
  },
  data() {
    return {
      tabIndex: 1
    };
  },
  computed: {
    tabs() {
      return [
        {
          key: "pass",
          label: "已核准",
          componentName: "pass"
        },
        {
          key: "applying",
          label: "申請中",
          componentName: "applying"
        },
        {
          key: "reject",
          label: "黑名單",
          componentName: "reject"
        },
        {
          key: "accountsLog",
          label: "帳號登錄紀錄",
          componentName: "accountsLog"
        }
      ];
    }
  }
};
</script>

<style lang="scss" scoped></style>
